import React from 'react';

const MailWhiteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M2 9.11L10.6507 13.6637C10.8693 13.7788 11.1307 13.7788 11.3493 13.6637L18.5564 9.87134C18.8566 9.95518 19.1731 10 19.5 10C19.6701 10 19.8373 9.98787 20.0009 9.96442L20 16.75C20 18.483 18.6435 19.8992 16.9344 19.9949L16.75 20H5.25C3.51697 20 2.10075 18.6435 2.00514 16.9344L2 16.75V9.11ZM16.337 4.99963C16.1209 5.45435 16 5.96306 16 6.5C16 7.469 16.3938 8.34602 17.03 8.97978L11 12.1525L2.09515 7.46618C2.43125 6.10891 3.62031 5.08813 5.06074 5.00542L5.25 5L16.337 4.99963ZM19.5 4C20.8807 4 22 5.11929 22 6.5C22 7.88071 20.8807 9 19.5 9C18.1193 9 17 7.88071 17 6.5C17 5.11929 18.1193 4 19.5 4Z"
      fill="white"
    />
  </svg>
);
export default MailWhiteIcon;
